import { serverTheme } from "@/lib/serverTheme";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Stack,
  SxProps,
  Theme,
} from "@mui/material";
import { ReactNode } from "react";

export const SLCardLight = ({
  title,
  badgeLabel,
  children,
  sx,
}: {
  title: string;
  badgeLabel: string;
  children: ReactNode;
  sx?: SxProps<Theme>;
}) => {
  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        backgroundColor: serverTheme.palette.background.default,
        position: "relative",
        ...((sx ?? {}) as object),
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        justifyContent="flex-end"
        sx={{
          mt: { xs: "16px", sm: "30px", md: "40px" },
          mx: { xs: "16px", sm: "30px", md: "40px" },
        }}
      >
        <Box>
          <Chip
            label={badgeLabel}
            slotProps={{
              label: {
                sx: {
                  fontSize: serverTheme.typography.body2.fontSize ?? 0,
                },
              },
            }}
            sx={{
              backgroundColor: serverTheme.palette.warning.light,
              color: serverTheme.palette.text.primary,
            }}
          />
        </Box>
      </Stack>
      <CardHeader
        title={title}
        slotProps={{
          root: {
            sx: {
              pt: { xs: "16px", sm: "24px", md: "24px !important" },
            },
          },
          title: {
            sx: {
              fontSize: serverTheme.typography.body1.fontSize ?? 0,
              fontWeight: 500,
              mb: 2,
            },
          },
        }}
      />
      <CardContent>
        <Stack direction="column" gap={2}>
          {children}
        </Stack>
      </CardContent>
    </Card>
  );
};
